import PropTypes from "prop-types";

/*
 * Four headline metrics. The reference shows loyalty points as the third
 * tile; there is no such field on the user, so saved items — which the
 * store does hold — takes that slot.
 */
const StatTiles = ({ tiles }) => (
  <ul className="c4prf__tiles">
    {tiles.map((tile) => (
      <li className={`c4prf__tile c4prf__tile--${tile.tone}`} key={tile.label}>
        <span className="c4prf__tile-value">{tile.value}</span>
        <span className="c4prf__tile-label">{tile.label}</span>
      </li>
    ))}
  </ul>
);

StatTiles.propTypes = {
  tiles: PropTypes.array.isRequired,
};

export default StatTiles;
